import {
    CREATE_OVERRIDDING_RISKFACTOR_SUCCESSFULL,
    CREATE_OVERRIDDING_RISKFACTOR_FAILURE,
    FETCH_OVERIDDING_RISKFACTOR_DETAILS_SUCCESS,
    FETCH_OVERIDDING_RISKFACTOR_DETAILS_FAILURE,
    EDIT_OVERRIDDING_RISKFACTOR_SUCCESSFULL,
    EDIT_OVERRIDDING_RISKFACTOR_FAILURE,
} from './Create/action';
import {
    OVERRIDDING_RISKFACTOR_LIST_SUCCESS,
    OVERRIDDING_RISKFACTOR_LIST_FAILURE
} from './List/action'
const initialState = {
    createOverriddingRiskFactorSuccess: null,
    createOverriddingRiskFactorFailure: null,
    overriddingRiskList: null,
    overriddingRiskListError: null,
    overriddingRiskFactorDetails: null,
    overriddingRiskFactorDetailsError: null,
    editSuccess: null,
    editFailed: null
}
const overriddingRiskFactorReducer = (state = initialState, action) => {
    switch (action.type) {
        case CREATE_OVERRIDDING_RISKFACTOR_SUCCESSFULL:
            return state = {
                ...state,
                createOverriddingRiskFactorSuccess: action.data
            }
        case CREATE_OVERRIDDING_RISKFACTOR_FAILURE:
            return state = {
                ...state,
                createOverriddingRiskFactorFailure: action.data
            }
        case OVERRIDDING_RISKFACTOR_LIST_SUCCESS:
            return state = {
                ...state,
                overriddingRiskList: action.data
            }
        case OVERRIDDING_RISKFACTOR_LIST_FAILURE:
            return state = {
                ...state,
                overriddingRiskListError: action.data
            }
        case FETCH_OVERIDDING_RISKFACTOR_DETAILS_SUCCESS:
            return state = {
                ...state,
                overriddingRiskFactorDetails: action.data
            }
        case FETCH_OVERIDDING_RISKFACTOR_DETAILS_FAILURE:
            return state = {
                ...state,
                overriddingRiskFactorDetailsError: action.data
            }
        case EDIT_OVERRIDDING_RISKFACTOR_SUCCESSFULL:
            return state = {
                ...state,
                editSuccess: action.data
            }
        case EDIT_OVERRIDDING_RISKFACTOR_FAILURE:
            return state = {
                ...state,
                editFailed: action.data
            }
        default: return state
    }
}

export default overriddingRiskFactorReducer;